<template>
  <VueJsModalPrimary
    v-bind="getModalAttrs"
    @before-close="beforeClose"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <HeaderLargePrimary :style="style.header">
        Edit Profile
      </HeaderLargePrimary>
      <FormTenantUserPrimary
        :form.sync="form"
        :tenantUser="tenantUser"
      />
      <div :style="style.bottom">
        <ButtonSecondary @click="close">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary
          :disabled="!form.isDifferentFrom(tenantUser)"
          @click="updateTenantUser"
        >
          Save
        </ButtonPrimary>
      </div>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import FormTenantUserPrimary from '@modules/v2/form/form-tenant-user-primary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { FormTenantUser } from '@js/forms/tenant-user'
  import { Layout } from '@js/styles'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalTenantUserPrimary',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      FormTenantUserPrimary,
      HeaderLargePrimary,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        form: new FormTenantUser(),
        name: MODAL_WINDOW_NAMES.UPDATE_TENANT_USER_PRIMARY,
        tenantUser: {},
        style: {
          bottom: {
            alignItems: 'flex-end',
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0 12px',
            width: '100%',
          },
          container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            padding: `${Layout.space.lg} 12px`,
            width: '100%',
          },
          header: {
            padding: '0 12px',
          },
        },
      };
    },
    computed: {
      getModalAttrs: function () {
        return {
          minHeight: 526,
          maxWidth: 720,
          name: this.name,
          width: '90%',
        };
      },
    },
    methods: {
      beforeClose: function () {
        this.clearCache();
      },
      beforeOpen: function (e) {
        this.clearCache();
        this.tenantUser = e?.params?.tenantUser;
        if (this.tenantUser === undefined || this.tenantUser === null) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to load user info',
          );
          this.close();
        }

        this.form.set(this.tenantUser);
      },
      clearCache: function () {
        this.form.clear();
      },
      close: function () {
        this.$modal.hide(this.name);
      },
      updateTenantUser: function () {
        this.$emit('update-tenant-user', this.form);
      },
    },
  };
</script>
